
  import * as ipxRuntime$H9hp670YGqkJOH5J3jE25lfpb0qc_pGnIMEUgIE7Sio from '/var/www/mysite/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['ipx']: { provider: ipxRuntime$H9hp670YGqkJOH5J3jE25lfpb0qc_pGnIMEUgIE7Sio, defaults: {} }
    }
  }
